module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__container"
  }, [(_vm.$slots.activator) ? _c('div', {
    ref: "activator",
    staticClass: "modal__activator",
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive
      }
    }
  }, [_vm._t("activator")], 2) : _vm._e(), _c('v-overlay', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    class: _vm.overlayClasses,
    domProps: {
      "value": (_vm.isActive)
    },
    on: {
      "input": function($event) {
        _vm.isActive = $event
      }
    }
  }, [_c(_vm.computedTransition, {
    tag: "component",
    attrs: {
      "origin": _vm.computedOrigin
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeConditional),
      expression: "closeConditional"
    }],
    ref: "modal",
    staticClass: "modal",
    class: _vm.classes,
    attrs: {
      "id": _vm.id
    }
  }, [_vm._t("default")], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fd8ee23!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/modal/Modal.vue
// module id = 114
// module chunks = 0